// account
export const login = '/Dashboards/Account/Login'

// admin
export const adminList = '/Admin/Dashboards/AdminList'
export const adminInfo = '/Admin/Dashboards/AdminInfo'
export const editAdmin = '/Admin/Dashboards/EditAdmin'
export const AddAdmin = '/Admin/Dashboards/AddAdmin'
export const delAdmin = '/Admin/Dashboards/DelAdmin'
export const currentAdminInfo = '/Admin/Dashboards/CurrentAdminInfo'
export const changePassword = '/Admin/Dashboards/ChangePassword'
export const uploadAdminAvatar = '/Admin/Dashboards/UploadAdminAvatar'
export const editCurrentAdmin = '/Admin/Dashboards/EditCurrentAdmin'

// loadLicense
export const loadLicense = '/Admin/Licenses/LoadLicense'

// role
export const roleList = '/Admin/Dashboards/RoleList'
export const allRoleList = '/Admin/Dashboards/AllRoleList'
export const addRole = '/Admin/Dashboards/AddRole'
export const roleInfo = '/Admin/Dashboards/RoleInfo'
export const editRole = '/Admin/Dashboards/editRole'
export const delRole = '/Admin/Dashboards/delRole'
export const moduleMenus = '/Admin/Dashboards/ModuleMenus'

// extendModule
export const extendModuleList = '/Admin/Dashboards/ExtendModuleList'
export const extendModuleEnabledChange = '/Admin/Dashboards/ExtendModuleEnabledChange'

// module
export const moduleList = '/Admin/Dashboards/ModuleList'
export const addModule = '/Admin/Dashboards/AddModule'
export const moduleInfo = '/Admin/Dashboards/ModuleInfo'
export const editModule = '/Admin/Dashboards/EditModule'
export const delModule = '/Admin/Dashboards/DelModule'
export const allUnmountModules = '/Admin/Dashboards/AllUnmountModules'
export const mountModule = '/Admin/Dashboards/MountModule'
export const editModuleSort = '/Admin/Dashboards/EditModuleSort'
export const moduleTree = '/Admin/Dashboards/ModuleTree'

// subSystem
export const subSystemList = '/Admin/Dashboards/SubSystemList'
export const addSubSystem = '/Admin/Dashboards/AddSubSystem'
export const subSystemInfo = '/Admin/Dashboards/SubSystemInfo'
export const editSubSystem = '/Admin/Dashboards/EditSubSystem'
export const delSubSystem = '/Admin/Dashboards/DelSubSystem'
export const subSystemTree = '/Admin/Dashboards/SubSystemTree'
export const editSubSystemSort = '/Admin/Dashboards/EditSubSystemSort'

// permissions
export const savePermissions = '/Admin/Dashboards/SavePermissions'

// merchant
export const merchantList = '/Admin/Merchant/MerchantList'
export const addMerchant = '/Admin/Merchant/AddMerchant'
export const merchantInfo = '/Admin/Merchant/MerchantInfo'
export const editMerchant = '/Admin/Merchant/EditMerchant'
export const delMerchant = '/Admin/Merchant/DelMerchant'

// merchantAdmin
export const merchantAdminList = '/Admin/Merchant/MerchantAdminList'
export const addMerchantAdmin = '/Admin/Merchant/AddMerchantAdmin'
export const merchantAdminInfo = '/Admin/Merchant/MerchantAdminInfo'
export const editMerchantAdmin = '/Admin/Merchant/EditMerchantAdmin'
export const delMerchantAdmin = '/Admin/Merchant/DelMerchantAdmin'

// merchantBill
export const merchantBillList = '/Admin/Merchant/MerchantBillList'
export const merchantBillInfo = '/Admin/Merchant/merchantBillInfo'

// antiChannelConflict

// dealer
export const dealerList = '/Admin/AntiChannelConflict/DealerList'
export const dealerExport = '/Admin/AntiChannelConflict/DealerExport'
export const addDealer = '/Admin/AntiChannelConflict/AddDealer'
export const dealerInfo = '/Admin/AntiChannelConflict/DealerInfo'
export const editDealer = '/Admin/AntiChannelConflict/EditDealer'
export const delDealer = '/Admin/AntiChannelConflict/DelDealer'
export const getDealerByParent = '/Admin/AntiChannelConflict/GetDealerByParent'
export const getDealerByRecommand = '/Admin/AntiChannelConflict/GetDealerByRecommand'
export const loadDealerList = '/Admin/AntiChannelConflict/LoadDealerList'
export const transferChildren = '/Admin/AntiChannelConflict/TransferChildren'
export const dealerResetPassword = '/Admin/AntiChannelConflict/ResetPassword'

// dealerLevel
export const dealerLevelList = '/Admin/AntiChannelConflict/DealerLevelList'
export const dealerLevelAllList = '/Admin/AntiChannelConflict/DealerLevelAllList'
export const addDealerLevel = '/Admin/AntiChannelConflict/AddDealerLevel'
export const dealerLevelInfo = '/Admin/AntiChannelConflict/GetDealerLevelInfo'
export const editDealerLevel = '/Admin/AntiChannelConflict/EditDealerLevel'
export const delDealerLevel = '/Admin/AntiChannelConflict/DelDealerLevel'

export const dealerSellAreaList = '/Admin/AntiChannelConflict/DealerSellAreaList'
export const importDealers = '/Admin/AntiChannelConflict/ImportDealers'
export const dealerPendingList = '/Admin/AntiChannelConflict/DealerPendingList'
export const auditingDealer = '/Admin/AntiChannelConflict/AuditingDealer'
export const updateDealerStatus = '/Admin/AntiChannelConflict/UpdateDealerStatus'
export const batchRemoveDealer = '/Admin/AntiChannelConflict/BatchRemoveDealer'

// dealerUpdate
export const dealerUpdatePendingList = '/Admin/AntiChannelConflict/DealerUpdatePendingList'
export const approvedDealerUpdate = '/Admin/AntiChannelConflict/ApprovedDealerUpdate'
export const rejectDealerUpdate = '/Admin/AntiChannelConflict/RejectDealerUpdate'

// dealerAccount
export const dealerAccountList = '/Admin/AntiChannelConflict/DealerAccountList'
export const addDealerAccount = '/Admin/AntiChannelConflict/AddDealerAccount'
export const editDealerAccount = '/Admin/AntiChannelConflict/EditDealerAccount'
export const delDealerAccount = '/Admin/AntiChannelConflict/DelDealerAccount'
export const dealerAccount = '/Admin/AntiChannelConflict/DealerAccount'

// inStock
export const inStockList = '/Admin/AntiChannelConflict/InStockList'
export const inStockInfo = '/Admin/AntiChannelConflict/InStockInfo'
export const delInStock = '/Admin/AntiChannelConflict/DelInStock'

// outStock
export const outStockList = '/Admin/AntiChannelConflict/OutStockList'
export const outStockInfo = '/Admin/AntiChannelConflict/OutStockInfo'
export const outStockShowOtherInfo = '/Admin/AntiChannelConflict/ShowOtherInfo'
export const addOutStock = '/Admin/AntiChannelConflict/AddOutStock'
export const addSimpleOutStock = '/Admin/AntiChannelConflict/AddSimpleOutStock'
export const editSimpleOutStock = '/Admin/AntiChannelConflict/EditSimpleOutStock'
export const batchRemoveOutStock = '/Admin/AntiChannelConflict/BatchRemoveOutStock'
export const batchBackStatusOutStock = '/Admin/AntiChannelConflict/BatchBackStatusOutStock'

// Stock
export const stockList = '/Admin/AntiChannelConflict/StockList'

// PDAAccount
export const pdaAccountList = '/Admin/AntiChannelConflict/PDAAccountList'
export const addPDAAccount = '/Admin/AntiChannelConflict/AddPDAAccount'
export const editPDAAccount = '/Admin/AntiChannelConflict/EditPDAAccount'
export const delPDAAccount = '/Admin/AntiChannelConflict/DelPDAAccount'

// PackingRule
export const PackingRuleList = '/Admin/AntiChannelConflict/PackingRuleList'
export const addPackingRule = '/Admin/AntiChannelConflict/addPackingRule'
export const editPackingRule = '/Admin/AntiChannelConflict/EditPackingRule'
export const delPackingRule = '/Admin/AntiChannelConflict/DelPackingRule'

// productReturn
export const productReturnList = '/Admin/AntiChannelConflict/ProductReturnList'
export const productReturnInfo = '/Admin/AntiChannelConflict/ProductReturnInfo'
export const delProductReturn = '/Admin/AntiChannelConflict/DelProductReturn'

// warehouse
export const warehouseList = '/Admin/AntiChannelConflict/WarehouseList'
export const addWarehouse = '/Admin/AntiChannelConflict/AddWarehouse'
export const warehouseInfo = '/Admin/AntiChannelConflict/WarehouseInfo'
export const editWarehouse = '/Admin/AntiChannelConflict/EditWarehouse'
export const delWarehouse = '/Admin/AntiChannelConflict/DelWarehouse'

// antiChannelConflictCode
export const antiChannelConflictCodeList = '/Admin/AntiChannelConflict/AntiChannelConflictCodeList'
export const antiChannelConflictQueryList = '/Admin/AntiChannelConflict/AntiChannelConflictQueryList'
export const antiChannelConflictTestList = '/Admin/AntiChannelConflict/GetList'

// area
export const loadAreas = '/Admin/Areas/LoadAreas'
export const loadFullNameAreas = '/Admin/Areas/LoadFullNameAreas'
export const lodaSelectedAreas = '/Admin/Areas/LodaSelectedAreas'
export const getProviceAreas = '/Admin/Areas/GetProviceAreas'
export const getAreasByParent = '/Admin/Areas/GetAreasByParent'
export const areaInfo = '/Admin/Areas/AreaInfo'
export const addArea = '/Admin/Areas/AddArea'
export const editArea = '/Admin/Areas/EditArea'
export const delArea = '/Admin/Areas/DelArea'

// TCL DeliveryInfo
export const deliveryInfoList = '/Admin/TCL/DeliveryInfoList'
export const addDeliveryInfo = '/Admin/TCL/AddDeliveryInfo'
export const deliveryInfoInfo = '/Admin/TCL/DeliveryInfoInfo'
export const editDeliveryInfo = '/Admin/TCL/EditDeliveryInfo'
export const delDeliveryInfo = '/Admin/TCL/DelDeliveryInfo'

// TCL AfterSale
export const afterSaleList = '/Admin/TCL/AfterSaleList'
export const afterSaleInfo = '/Admin/TCL/AfterSaleInfo'
export const handleAfterSale = '/Admin/TCL/HandleAfterSale'
export const unHandledAfterSaleList = '/Admin/TCL/UnHandledAfterSaleList'
export const handledAfterSaleList = '/Admin/TCL/HandledAfterSaleList'

// antiFake
// antiFakeCode
export const antiFakeCodeList = '/Admin/AntiFake/AntiFakeCodeList'
export const antiFakeCodeInfo = '/Admin/AntiFake/AntiFakeCodeInfo'

// antiFakeQuery
export const antiFakeQueryList = '/Admin/AntiFake/AntiFakeQueryList'
export const antiFakeQueryInfo = '/Admin/AntiFake/AntiFakeQueryInfo'

// antiFakeResponse
export const antiFakeResponseList = '/Admin/AntiFake/AntiFakeResponseList'
export const antiFakeResponseInfo = '/Admin/AntiFake/AntiFakeResponseInfo'
export const addAntiFakeResponse = '/Admin/AntiFake/AddAntiFakeResponse'
export const editAntiFakeResponse = '/Admin/AntiFake/EditAntiFakeResponse'
export const delAntiFakeResponse = '/Admin/AntiFake/DelAntiFakeResponse'
export const loadUnRelationshipIssuerRecords = '/Admin/AntiFake/LoadUnRelationshipIssuerRecords'

// issuerCodes
export const issuerCodeList = '/Admin/IssuerCodes/IssuerCodeList'
export const issuerCodeInfo = '/Admin/IssuerCodes/IssuerCodeInfo'

// issuerRecord
export const issuerRecordList = '/Admin/IssuerCodes/IssuerRecordList'
export const issuerRecordInfo = '/Admin/IssuerCodes/IssuerRecordInfo'
export const addIssuerRecord = '/Admin/IssuerCodes/AddIssuerRecord'
export const editIssuerRecord = '/Admin/IssuerCodes/EditIssuerRecord'
export const delIssuerRecord = '/Admin/IssuerCodes/DelIssuerRecord'

// products
// brand
export const brandList = '/Admin/Products/BrandList'
export const brandInfo = '/Admin/Products/BrandInfo'
export const addBrand = '/Admin/Products/AddBrand'
export const editBrand = '/Admin/Products/EditBrand'
export const delBrand = '/Admin/Products/DelBrand'

// product
export const productList = '/Admin/Products/ProductList'
export const productInfo = '/Admin/Products/ProductInfo'
export const addProduct = '/Admin/Products/AddProduct'
export const editProduct = '/Admin/Products/EditProduct'
export const delProduct = '/Admin/Products/DelProduct'
export const imgUpload = '/Admin/Products/UploadPhoto'
export const editProductStatus = '/Admin/Products/EditProductStatus'
export const importProducts = '/Admin/Products/ImportProducts'
export const batchRemoveProduct = '/Admin/Products/BatchRemoveProduct'

// product order
export const orderList = '/Admin/Orders/OrderList'
export const addTotal = '/Admin/Orders/AddTotalOrder'
export const orderInfo = '/Admin/Orders/OrderInfo'
export const addOrder = '/Admin/Orders/AddOrder'
export const importOrder = '/Admin/Orders/ImportOrder'

// activity marketingUserArea
export const marketingMDUserAreaList = '/Admin/MarketingManDi/MarketingUserAreaList'
export const marketingKDEUserAreaList = '/Admin//MarketingKaDiEr/MarketingUserAreaList'

// activity helpAwardTotal
export const helpAwardTotalList = '/Admin/MarketingQinQin/HelpList'
export const editHelpAwardTotalInfo = '/Admin/MarketingQinQin/EditHelpInfo'
export const helpAwardTotalExport = '/Admin/MarketingQinQin/HelpAwardTotalExport'

// activity helpAwardInformation
export const helpAwardInformationlList = '/Admin/MarketingQinQin/HelpAwardList'

// activity freeAwardInformation
export const freeAwardInformationlList = '/Admin/MarketingQinQin/FreeAwardInformationList'
export const freeAwardInformationExport = '/Admin/MarketingQinQin/FreeAwardInformationExport'
export const editFreeAwardInformation = '/Admin/MarketingQinQin/EditFreeAwardInformation'

// activity ActivityUserGran
export const activityUserGrantList = '/Admin/MarketingShengJie/ActivityUserGrantList'
export const delUserGrants = '/Admin/MarketingShengJie/DelUserGrant'
export const changeUserGrantStatus = '/Admin/MarketingShengJie/ChangeUserGrantStatus'
export const batchChangeUserGrantStatus = '/Admin/MarketingShengJie/BatchChangeUserGrantStatus'

// productSku
export const productSkuList = '/Admin/Products/ProductSkuList'
export const getProductSkuColumn = '/Admin/Products/GetProductSkuColumn'
export const addSku = '/Admin/Products/AddSku'
export const editSku = '/Admin/Products/EditSku'
export const delSku = '/Admin/Products/DelSku'

// productCategory
export const productCategoryTree = '/Admin/Products/ProductCategoryTree'
export const productCategoryList = '/Admin/Products/ProductCategoryList'
export const addProductCategory = '/Admin/Products/AddProductCategory'
export const editProductCategory = '/Admin/Products/EditProductCategory'
export const productCategoryInfo = '/Admin/Products/ProductCategoryInfo'
export const delProductCategory = '/Admin/Products/DelProductCategory'
export const setProductCategorySort = '/Admin/Products/SetProductCategorySort'
export const getTopCategory = '/Admin/Products/GetTopCategory'

// productPropertyCategory
export const productPropertyCategoryList = '/Admin/Products/ProductPropertyCategoryList'
export const addProductPropertyCategory = '/Admin/Products/AddProductPropertyCategory'
export const editProductPropertyCategory = '/Admin/Products/EditProductPropertyCategory'
export const productPropertyCategoryInfo = '/Admin/Products/ProductPropertyCategoryInfo'
export const delProductPropertyCategory = '/Admin/Products/DelProductPropertyCategory'
export const getProductPropertyCategoryPropertyVaules = '/Admin/Products/GetProductPropertyCategoryPropertyVaules'
export const relationPropertyValues = '/Admin/Products/RelationPropertyValues'
export const getProductPropertyList = '/Admin/Products/GetProductPropertyList'
export const getProductPropertyValuesByRootValue = '/Admin/Products/GetProductPropertyValuesByRootValue'
export const delRelationPropertyValue = '/Admin/Products/DelRelationPropertyValue'
export const productCategoryCascader = '/Admin/Products/ProductCategoryCascader'

// productProperty
export const productPropertyList = '/Admin/Products/ProductPropertyList'
export const addProductProperty = '/Admin/Products/AddProductProperty'
export const editProductProperty = '/Admin/Products/EditProductProperty'
export const productPropertyInfo = '/Admin/Products/ProductPropertyInfo'
export const delProductProperty = '/Admin/Products/DelProductProperty'

// productPropertyValue
export const productPropertyValueList = '/Admin/Products/ProductPropertyValueList'
export const addProductPropertyValue = '/Admin/Products/AddProductPropertyValue'
export const editProductPropertyValue = '/Admin/Products/EditProductPropertyValue'
export const productPropertyValueInfo = '/Admin/Products/ProductPropertyValueInfo'
export const delProductPropertyValue = '/Admin/Products/DelProductPropertyValue'
export const setProductPropertyValueSort = '/Admin/Products/SetProductPropertyValueSort'

// productParamsTemplate
export const productParamsTemplateList = '/Admin/Products/ProductParamsTemplateList'
export const addProductParamsTemplate = '/Admin/Products/AddProductParamsTemplate'
export const editProductParamsTemplate = '/Admin/Products/EditProductParamsTemplate'

// payment
export const paymentConfigList = '/Admin/Payment/PaymentConfigList'
export const paymentModeList = '/Admin/Payment/PaymentModeList'
export const addPaymentConfig = '/Admin/Payment/AddPaymentConfig'
export const editPaymentConfig = '/Admin/Payment/EditPaymentConfig'
export const paymentConfigInfo = '/Admin/Payment/PaymentConfigInfo'
export const delPaymentConfig = '/Admin/Payment/DelPaymentConfig'
export const uploadPaymentCert = '/Admin/Payment/UploadPaymentCert'

// SMS
export const smsConfigList = '/Admin/SMS/SmsConfigList'
export const smsProviderList = '/Admin/SMS/SmsProviderList'
export const addSmsConfig = '/Admin/SMS/AddSmsConfig'
export const editSmsConfig = '/Admin/SMS/EditSmsConfig'
export const smsConfigInfo = '/Admin/SMS/SmsConfigInfo'
export const delSmsConfig = '/Admin/SMS/DelSmsConfig'
export const setSmsConfigDefault = '/Admin/SMS/SetSmsConfigDefault'
export const setSmsConfigStatus = '/Admin/SMS/SetSmsConfigStatus'
export const smsTemplateList = '/Admin/SMS/SmsTemplateList'
export const smsTemplateKeys = '/Admin/SMS/SmsTemplateKeys'
export const addSmsTemplate = '/Admin/SMS/AddSmsTemplate'
export const editSmsTemplate = '/Admin/SMS/EditSmsTemplate'
export const delSmsTemplate = '/Admin/SMS/DelSmsTemplate'
export const smsLogList = '/Admin/SMS/SmsLogList'
export const newSmsConfigList = '/Admin/SMS/NewSmsConfigList'
export const newDelSmsConfig = '/Admin/SMS/NewDelSmsConfig'
export const addNewSmsConfig = '/Admin/SMS/AddNewSmsConfig'
export const newSmsConfigInfo = '/Admin/SMS/NewSmsConfigInfo'
export const editNewSmsConfig = '/Admin/SMS/EditNewSmsConfig'

// FengYeRedPacket
export const aliyunSMSList = '/Admin/FengYeRedPacket/SmsConfigList'
export const delAliyunSmsConfig = '/Admin/FengYeRedPacket/DelSmsConfig'
export const smsAliyunProviderList = '/Admin/FengYeRedPacket/SmsProviderList'
export const addAliyunSmsConfig = '/Admin/FengYeRedPacket/AddSmsConfig'
export const smsAliyunInfo = '/Admin/FengYeRedPacket/SmsConfigInfo'
export const editAliyunSmsConfig = '/Admin/FengYeRedPacket/EditSmsConfig'
export const logList = '/Admin/FengYeRedPacket/LogList'
export const batchRemoveLog = '/Admin/FengYeRedPacket/BatchRemoveLog'

// MingHui RedPacket
export const mingHuiSMSList = '/Admin/MingHuiRed/SmsConfigList'
export const delMingHuiSmsConfig = '/Admin/MingHuiRed/DelSmsConfig'
export const smsMingHuiProviderList = '/Admin/MingHuiRed/SmsProviderList'
export const addMingHuiSmsConfig = '/Admin/MingHuiRed/AddSmsConfig'
export const smsMingHuiInfo = '/Admin/MingHuiRed/SmsConfigInfo'
export const editMingHuiSmsConfig = '/Admin/MingHuiRed/EditSmsConfig'
export const mingHuilogList = '/Admin/MingHuiRed/LogList'
export const mingHuibatchRemoveLog = '/Admin/MingHuiRed/BatchRemoveLog'

// deliveryTemplate
export const deliveryTemplateList = '/Admin/DeliveryTemplates/deliveryTemplateList'
export const addDeliveryTemplate = '/Admin/DeliveryTemplates/AddDeliveryTemplate'
export const editDeliveryTemplate = '/Admin/DeliveryTemplates/EditDeliveryTemplate'
export const deliveryTemplateInfo = '/Admin/DeliveryTemplates/DeliveryTemplateInfo'
export const delDeliveryTemplate = '/Admin/DeliveryTemplates/DelDeliveryTemplate'
export const setDeliveryTemplateDefault = '/Admin/DeliveryTemplates/SetDeliveryTemplateDefault'

// siteProps
export const sitePropList = '/Admin/SiteProps/SitePropList'
export const editSiteProp = '/Admin/SiteProps/EditSiteProp'
export const getSystemSetTitle = '/Admin/SiteProps/SystemSetTitle'

// officialAccount
export const officialAccountInfo = '/Admin/OfficialAccounts/OfficialAccountInfo'
export const editOfficialAccount = '/Admin/OfficialAccounts/EditOfficialAccount'
export const uploadOfficialAccountPhoto = '/Admin/OfficialAccounts/UploadOfficialAccountPhoto'
export const uploadOfficialAccountTenPayCert = '/Admin/OfficialAccounts/UploadOfficialAccountTenPayCert'

// user
export const userList = '/Admin/OfficialAccounts/UserList'
export const userInfo = '/Admin/OfficialAccounts/UserInfo'
export const changeUserStatus = '/Admin/OfficialAccounts/ChangeUserStatus'
export const batchChangeOpenId = '/Admin/OfficialAccounts/BatchChangeOpenId'

// templateMessage
export const templateMessageList = '/Admin/OfficialAccounts/TemplateMessageList'
export const templateMessageInfo = '/Admin/OfficialAccounts/TemplateMessageInfo'
export const editTemplateMessage = '/Admin/OfficialAccounts/EditTemplateMessage'

// officialAccountMenu
export const officialAccountMenuList = '/Admin/OfficialAccounts/OfficialAccountMenuList'
export const addOfficialAccountMenu = '/Admin/OfficialAccounts/AddOfficialAccountMenu'
export const editOfficialAccountMenu = '/Admin/OfficialAccounts/EditOfficialAccountMenu'
export const officialAccountMenuInfo = '/Admin/OfficialAccounts/OfficialAccountMenuInfo'
export const delOfficialAccountMenu = '/Admin/OfficialAccounts/DelOfficialAccountMenu'
export const publishOfficialAccountMenu = '/Admin/OfficialAccounts/PublishOfficialAccountMenu'
export const newsMediaList = '/Admin/OfficialAccounts/NewsMediaList'
export const othersMediaLis = '/Admin/OfficialAccounts/OthersMediaLis'
export const getForeverNews = '/Admin/OfficialAccounts/GetForeverNews'

// scheduledTask
export const scheduledTaskList = '/Admin/Scheduling/ScheduledTaskList'
export const scheduledTaskInfo = '/Admin/Scheduling/ScheduledTaskInfo'
export const editScheduledTask = '/Admin/Scheduling/EditScheduledTask'

// Advertising
export const advertList = '/Admin/Advertising/AdvertList'
export const saveAdvert = '/Admin/Advertising/SaveAdvert'
export const advertInfo = '/Admin/Advertising/AdvertInfo'

// advertItem
export const advertItemList = '/Admin/Advertising/AdvertItemList'
export const addAdvertItem = '/Admin/Advertising/AddAdvertItem'
export const editAdvertItem = '/Admin/Advertising/EditAdvertItem'
export const advertItemInfo = '/Admin/Advertising/AdvertItemInfo'
export const delAdvertInfo = '/Admin/Advertising/DelAdvertInfo'
export const uploadAdvertItemPhoto = '/Admin/Advertising/UploadAdvertItemPhoto'

// express
export const expressList = '/Admin/Expresses/ExpressList'
export const addExpress = '/Admin/Expresses/AddExpress'
export const expressInfo = '/Admin/Expresses/ExpressInfo'
export const editExpress = '/Admin/Expresses/EditExpress'
export const delExpress = '/Admin/Expresses/DelExpress'
export const uploadExpressPhoto = '/Admin/Expresses/UploadExpressPhoto'
export const allExpress = '/Admin/Expresses/AllExpress'

// ServicePromise
export const servicePromiseList = '/Admin/Mall/ServicePromiseList'
export const addServicePromise = '/Admin/Mall/AddServicePromise'
export const servicePromiseInfo = '/Admin/Mall/ServicePromiseInfo'
export const editServicePromise = '/Admin/Mall/EditServicePromise'
export const delServicePromise = '/Admin/Mall/DelServicePromise'
export const uploadServicePromisePhoto = '/Admin/Mall/UploadServicePromisePhoto'

// order
export const mallMasterOrderList = '/Admin/Mall/MallMasterOrderList'
export const shippingMallOrder = '/Admin/Mall/ShippingMallOrder'
export const mallOrderInfo = '/Admin/Mall/MallOrderInfo'
export const mallOrderList = '/Admin/Mall/MallOrderList'
export const closeMallOrder = '/Admin/Mall/CloseMallOrder'
export const mallExpressList = '/Admin/Mall/MallExpressList'
export const FinishedMallOrder = '/Admin/Mall/FinishedMallOrder'
export const mallOrderPay = './Admin/Mall/MallOrderPay'

// mallProduct
export const mallProductList = '/Admin/Mall/MallProductList'
export const addMallProduct = '/Admin/Mall/AddMallProduct'
export const editMallProduct = '/Admin/Mall/EditMallProduct'
export const mallProductInfo = '/Admin/Mall/MallProductInfo'
export const delMallProduct = '/Admin/Mall/DelMallProduct'
export const editMallProductStatus = '/Admin/Mall/EditMallProductStatus'
export const uploadMallProductPhoto = '/Admin/Mall/UploadMallProductPhoto'
export const importMallProducts = '/Admin/Mall/ImportMallProducts'

// mallProductSku
export const mallProductSkuList = '/Admin/Mall/MallProductSkuList'
export const addMallProductSku = '/Admin/Mall/AddMallProductSku'
export const editMallProductSku = '/Admin/Mall/EditMallProductSku'
export const delMallProductSku = '/Admin/Mall/DelMallProductSku'
export const getMallProductSkuColumn = '/Admin/Mall/GetMallProductSkuColumn'

// mallBrand
export const mallBrandList = '/Admin/Mall/MallBrandList'
export const mallBrandInfo = '/Admin/Mall/MallBrandInfo'
export const addMallBrand = '/Admin/Mall/AddMallBrand'
export const editMallBrand = '/Admin/Mall/EditMallBrand'
export const delMallBrand = '/Admin/Mall/DelMallBrand'

// mallProductCategory
export const mallProductCategoryTree = '/Admin/Mall/MallProductCategoryTree'
export const mallProductCategoryCascader = '/Admin/Mall/MallProductCategoryCascader'
export const mallProductCategoryList = '/Admin/Mall/MallProductCategoryList'
export const addMallProductCategory = '/Admin/Mall/AddMallProductCategory'
export const editMallProductCategory = '/Admin/Mall/EditMallProductCategory'
export const mallProductCategoryInfo = '/Admin/Mall/MallProductCategoryInfo'
export const delMallProductCategory = '/Admin/Mall/DelMallProductCategory'
export const setMallProductCategorySort = '/Admin/Mall/SetMallProductCategorySort'
export const getTopMallCategory = '/Admin/Mall/GetTopMallCategory'

// MallProductProperty
export const mallProductPropertyList = '/Admin/Mall/MallProductPropertyList'
export const addMallProductProperty = '/Admin/Mall/AddMallProductProperty'
export const editMallProductProperty = '/Admin/Mall/EditMallProductProperty'
export const mallProductPropertyInfo = '/Admin/Mall/MallProductPropertyInfo'
export const delMallProductProperty = '/Admin/Mall/DelMallProductProperty'

// mallProductPropertyCategory
export const mallProductPropertyCategoryList = '/Admin/Mall/MallProductPropertyCategoryList'
export const addMallProductPropertyCategory = '/Admin/Mall/AddMallProductPropertyCategory'
export const editMallProductPropertyCategory = '/Admin/Mall/EditMallProductPropertyCategory'
export const mallProductPropertyCategoryInfo = '/Admin/Mall/MallProductPropertyCategoryInfo'
export const delMallProductPropertyCategory = '/Admin/Mall/DelMallProductPropertyCategory'
export const getMallPropertyVaules = '/Admin/Mall/GetMallPropertyVaules'
export const getMallProductPropertyList = '/Admin/Mall/GetMallProductPropertyList'
export const getMallProductPropertyValuesByRootValue = '/Admin/Mall/GetMallProductPropertyValuesByRootValue'
export const relationMallPropertyValues = '/Admin/Mall/RelationMallPropertyValues'
export const delRelationMallPropertyValue = '/Admin/Mall/DelRelationMallPropertyValue'

// mallProductPropertyValue
export const mallProductPropertyValueList = '/Admin/Mall/MallProductPropertyValueList'
export const addMallProductPropertyValue = '/Admin/Mall/AddMallProductPropertyValue'
export const editMallProductPropertyValue = '/Admin/Mall/EditMallProductPropertyValue'
export const mallProductPropertyValueInfo = '/Admin/Mall/MallProductPropertyValueInfo'
export const delMallProductPropertyValue = '/Admin/Mall/DelMallProductPropertyValue'
export const setMallProductPropertyValueSort = '/Admin/Mall/SetMallProductPropertyValueSort'

// mallProductParams
export const mallProductParamsTemplateList = '/Admin/Mall/MallProductParamsTemplateList'
export const addMallProductParamsTemplate = '/Admin/Mall/AddMallProductParamsTemplate'
export const editMallProductParamsTemplate = '/Admin/Mall/EditMallProductParamsTemplate'
export const mallProductParamsTemplateInfo = '/Admin/Mall/MallProductParamsTemplateInfo'
export const delMallProductParamsTemplate = '/Admin/Mall/DelMallProductParamsTemplate'

// mall-integral
export const integralList = '/Admin/Mall/IntegralList'
export const integralInfo = '/Admin/Mall/IntegralInfo'
export const addIntegral = '/Admin/Mall/AddIntegral'
export const editIntegral = '/Admin/Mall/EditIntegral'
export const delIntegral = '/Admin/Mall/DelIntegral'
export const editIntegralStatus = '/Admin/Mall/EditIntegralStatus'

// replenishment
// replenishmentOrder
export const replenishOrderList = '/Admin/Replenishment/ReplenishOrderList'
// export const shippingReplenishOrder = '/Admin/Replenishment/ShippingReplenishOrder'
export const replenishOrderInfo = '/Admin/Replenishment/ReplenishOrderInfo'
export const replenishOrderShip = '/Admin/Replenishment/ReplenishOrderShip'
export const replenishExpressDrowList = '/Admin/Replenishment/ExpressDrowList'
export const replenishOrderStatusList = '/Admin/Replenishment/OrderStatusList'
export const replenishUpdateOrderStatus = '/Admin/Replenishment/UpdateOrderStatus'
export const replenishOrderClose = '/Admin/Replenishment/CloseReplenishOrder'
export const replenishOrderPay = '/Admin/Replenishment/PayReplenishOrder'
export const replenishOrderFinished = '/Admin/Replenishment/FinishedReplenishOrder'

// replenishProduct
export const replenishProductList = '/Admin/Replenishment/ReplenishProductList'
export const addReplenishProduct = '/Admin/Replenishment/AddReplenishProduct'
export const editReplenishProduct = '/Admin/Replenishment/EditReplenishProduct'
export const replenishProductInfo = '/Admin/Replenishment/ReplenishProductInfo'
export const delReplenishProduct = '/Admin/Replenishment/DelReplenishProduct'
export const editReplenishProductStatus = '/Admin/Replenishment/EditReplenishProductStatus'
export const uploadPhoto = '/Admin/Replenishment/UploadPhoto'
export const importReplenishProducts = '/Admin/Replenishment/ImportReplenishProducts'

// replenishProductSku
export const replenishProductSkuList = '/Admin/Replenishment/ReplenishProductSkuList'
export const addReplenishProductSku = '/Admin/Replenishment/AddReplenishProductSku'
export const editReplenishProductSku = '/Admin/Replenishment/EditReplenishProductSku'
export const delReplenishProductSku = '/Admin/Replenishment/DelReplenishProductSku'
export const getReplenishProductSkuColumn = '/Admin/Replenishment/GetReplenishProductSkuColumn'

// replenishProductBrand
export const replenishProductBrandList = '/Admin/Replenishment/ReplenishProductBrandList'
export const replenishProductBrandInfo = '/Admin/Replenishment/ReplenishProductBrandInfo'
export const addreplenishProductBrand = '/Admin/Replenishment/AddReplenishProductBrand'
export const editreplenishProductBrand = '/Admin/Replenishment/EditReplenishProductBrand'
export const delreplenishProductBrand = '/Admin/Replenishment/DelReplenishProductBrand'

// replenishProductCategory
export const replenishProductCategoryTree = '/Admin/Replenishment/ProductCategoryTree'
export const replenishProductCategoryList = '/Admin/Replenishment/ProductCategoryList'
export const addReplenishProductCategory = '/Admin/Replenishment/AddProductCategory'
export const editReplenishProductCategory = '/Admin/Replenishment/EditProductCategory'
export const replenishProductCategoryInfo = '/Admin/Replenishment/ProductCategoryInfo'
export const delReplenishProductCategory = '/Admin/Replenishment/DelProductCategory'
export const setReplenishProductCategorySort = '/Admin/Replenishment/SetProductCategorySort'
export const getReplenishTopCategory = '/Admin/Replenishment/GetTopCategory'
export const replenishProductCategoryCascader = '/Admin/Replenishment/ProductCategoryCascader'

// replenishproductPropertyCategory
export const replenishProductPropertyCategoryList = '/Admin/Replenishment/ProductPropertyCategoryList'
export const addReplenishProductPropertyCategory = '/Admin/Replenishment/AddProductPropertyCategory'
export const editReplenishProductPropertyCategory = '/Admin/Replenishment/EditProductPropertyCategory'
export const replenishProductPropertyCategoryInfo = '/Admin/Replenishment/ProductPropertyCategoryInfo'
export const delReplenishProductPropertyCategory = '/Admin/Replenishment/DelProductPropertyCategory'
export const getReplenishProductPropertyCategoryPropertyVaules = '/Admin/Replenishment/GetProductPropertyCategoryPropertyVaules'
export const relationReplenishPropertyValues = '/Admin/Replenishment/RelationPropertyValues'
export const getReplenishProductPropertyList = '/Admin/Replenishment/GetProductPropertyList'
export const getReplenishProductPropertyValuesByRootValue = '/Admin/Replenishment/GetProductPropertyValuesByRootValue'
export const delReplenishRelationPropertyValue = '/Admin/Replenishment/DelRelationPropertyValue'

// replenishproductProperty
export const replenishProductPropertyList = '/Admin/Replenishment/ProductPropertyList'
export const addReplenishProductProperty = '/Admin/Replenishment/AddProductProperty'
export const editReplenishProductProperty = '/Admin/Replenishment/EditProductProperty'
export const replenishProductPropertyInfo = '/Admin/Replenishment/ProductPropertyInfo'
export const delReplenishProductProperty = '/Admin/Replenishment/DelProductProperty'

// replenishproductPropertyValue
export const replenishProductPropertyValueList = '/Admin/Replenishment/ReplenishProductPropertyValueList'
export const addReplenishProductPropertyValue = '/Admin/Replenishment/AddReplenishProductPropertyValue'
export const editReplenishProductPropertyValue = '/Admin/Replenishment/EditReplenishProductPropertyValue'
export const replenishProductPropertyValueInfo = '/Admin/Replenishment/ReplenishProductPropertyValueInfo'
export const delReplenishProductPropertyValue = '/Admin/Replenishment/DelReplenishProductPropertyValue'
export const setReplenishProductPropertyValueSort = '/Admin/Replenishment/SetReplenishProductPropertyValueSort'

// replenishproductParamsTemplate
export const replenishProductParamsTemplateList = '/Admin/Replenishment/ProductParamsTemplateList'
export const addReplenishProductParamsTemplate = '/Admin/Replenishment/AddProductParamsTemplate'
export const editReplenishProductParamsTemplate = '/Admin/Replenishment/EditProductParamsTemplate'

// chart
export const chartInfo = '/Admin/Marketing/ChartInfo'
export const chartUserInfo = '/Admin/Marketing/UserInfo'
export const chartActivityRate = '/Admin/Marketing/ActivityRate'
export const chartLuckDraw = '/Admin/Marketing/LuckDraw'
export const chartUserLoyalty = '/Admin/Marketing/UserLoyalty'

// activity
export const payBalanceInfo = '/Admin/Marketing/PayBalanceInfo'
export const activityList = '/Admin/Marketing/ActivityList'
export const addActivity = '/Admin/Marketing/AddActivity'
export const editActivity = '/Admin/Marketing/EditActivity'
export const activityInfo = '/Admin/Marketing/ActivityInfo'
export const delActivity = '/Admin/Marketing/DelActivity'
export const LotteryRecordExport = '/Admin/Marketing/LotteryRecordExport'
export const activityTypeList = '/Admin/Marketing/ActivityTypeList'
export const lotteryRecordList = '/Admin/Marketing/LotteryRecordList'
export const editLotteryRecord = '/Admin/Marketing/EditLotteryRecord'
export const lotteryRecordInfo = '/Admin/Marketing/LotteryRecordInfo'
export const loadIssureRecords = '/Admin/Marketing/LoadUnRelationshipIssuerRecords'
export const redPacketDateList = '/Admin/Marketing/RedPacketDateList'
export const uploadActivityBackgroundPhoto = '/Admin/Marketing/UploadActivityBackgroundPhoto'

// award
export const awardList = '/Admin/Marketing/AwardList'
export const addAward = '/Admin/Marketing/AddAward'
export const editAward = '/Admin/Marketing/EditAward'
export const awardInfo = '/Admin/Marketing/AwardInfo'
export const delAward = '/Admin/Marketing/DelAward'
export const awardTypeList = '/Admin/Marketing/AwardTypeList'
export const uploadAwardPhoto = '/Admin/Marketing/UploadAwardPhoto'

// exhibitionHall
export const exActivityList = '/Admin/ExhibitionHall/ActivityList'
export const exActivityUserList = '/Admin/ExhibitionHall/ActivityUserList'
export const exAwardList = '/Admin/ExhibitionHall/AwardList'
export const exWinnerList = '/Admin/ExhibitionHall/WinnerList'

// updater
// resource
export const resourceList = '/Admin/Updater/ResourceList'
export const addResource = '/Admin/Updater/AddResource'
export const editResource = '/Admin/Updater/EditResource'
export const resourceInfo = '/Admin/Updater/ResourceInfo'
export const delResource = '/Admin/Updater/DelResource'

// resourceUpdate
export const resourceUpdateList = '/Admin/Updater/ResourceUpdateList'
export const addResourceUpdate = '/Admin/Updater/AddResourceUpdate'
export const editResourceUpdate = '/Admin/Updater/EditResourceUpdate'
export const resourceUpdateInfo = '/Admin/Updater/ResourceUpdateInfo'
export const delResourceUpdate = '/Admin/Updater/DelResourceUpdate'
export const uploadResourceUpdate = '/Admin/Updater/UploadResourceUpdate'

// CheckUserAccount
export const checkUserAccountList = '/Admin/AntiChannelConflict/CheckUserAccountList'
export const addCheckUserAccount = '/Admin/AntiChannelConflict/AddCheckUserAccount'
export const editCheckUserAccount = '/Admin/AntiChannelConflict/EditCheckUserAccount'
export const delCheckUserAccount = '/Admin/AntiChannelConflict/DelCheckUserAccount'

// Sales
// POSSeller
export const possellerList = '/Admin/Sales/POSSellerList'
export const possellerPendingList = '/Admin/Sales/POSSellerPendingList'
export const auditingPOSSeller = '/Admin/Sales/AuditingPOSSeller'
export const updateStatusPOSSeller = '/Admin/Sales/UpdateStatusPOSSeller'
export const possellerInfo = '/Admin/Sales/POSSellerInfo'
export const editPOSSeller = '/Admin/Sales/EditPOSSeller'

// POS
export const posNameList = '/Admin/Sales/POSNameList'
export const posList = '/Admin/Sales/POSList'
export const delPOS = '/Admin/Sales/DelPOS'
export const addPOS = '/Admin/Sales/AddPOS'
export const editPOS = '/Admin/Sales/EditPOS'
export const posInfo = '/Admin/Sales/POSInfo'

// AreaManager
export const areaManagerNameList = '/Admin/Sales/AreaManagerNameList'
export const areaManagerList = '/Admin/Sales/AreaManagerList'
export const addAreaManager = '/Admin/Sales/AddAreaManager'
export const areaManagerInfo = '/Admin/Sales/AreaManagerInfo'
export const editAreaManager = '/Admin/Sales/EditAreaManager'
export const delAreaManager = '/Admin/Sales/DelAreaManager'
export const areaManagerInfoList = '/Admin/Sales/AreaManagerInfoList'

// WeChatExcellent
export const productDealerSkuList = '/Admin/WeChatExcellent/DealerProductList'
export const weChatExcellentJoinInApplyList = '/Admin/WeChatExcellent/JoinInApplyList'
export const weChatExcellentJoinInApplyInfo = '/Admin/WeChatExcellent/GetJoinInApplyInfo'
export const weChatExcellentJoinInApplyEdit = '/Admin/WeChatExcellent/EditJoinInApplyInfo'
export const weChatExcellentDealerBlackList = '/Admin/WeChatExcellent/DealerBlackList'
export const weChatExcellentAddDealerBlack = '/Admin/WeChatExcellent/AddDealerBlack'
export const weChatExcellentGetDealerList = '/Admin/WeChatExcellent/GetDealerList'
export const weChatExcellentDeleteDealerBlack = '/Admin/WeChatExcellent/DeleteDealerBlack'
export const weChatExcellentProductDealerPriceList = '/Admin/WeChatExcellent/ProductDealerPriceList'
export const weChatExcellentProductDealerDefaultPriceList = '/Admin/WeChatExcellent/ProductDealerDefaultPriceList'
export const weChatExcellentProductDealerSkuPriceList = '/Admin/WeChatExcellent/ProductDealerSkuPriceList'
export const weChatExcellentProductDealerPriceEdit = '/Admin/WeChatExcellent/ProductDealerPriceEdit'
export const weChatExcellentProductDealerPriceDelete = '/Admin/WeChatExcellent/ProductDealerPriceDelete'
export const weChatExcellentMessageList = '/Admin/WeChatExcellent/MessageList'
export const weChatExcellentMessageInfo = '/Admin/WeChatExcellent/GetMessageInfo'
export const weChatExcellentAddMessage = '/Admin/WeChatExcellent/AddMessage'
export const weChatExcellentDeleteMessage = '/Admin/WeChatExcellent/DeleteMessage'

export const weChatExcellentProductExtendList = '/Admin/WeChatExcellent/ProductExtendList'
export const weChatExcellentProductExtendEdit = '/Admin/WeChatExcellent/ProductExtendEdit'
export const weChatExcellentProductExtendInfo = '/Admin/WeChatExcellent/ProductExtendInfo'
export const weChatExcellentProductExtendDelete = '/Admin/WeChatExcellent/ProductExtendDelete'
export const weChatExcellentUploadProductExtendVideo = '/Admin/WeChatExcellent/UploadProductExtendVideo'

// Report
export const wechatExcellentPersonalReport = '/Admin/WeChatExcellent/PersonalReport'
export const wechatExcellentTeamReport = '/Admin/WeChatExcellent/TeamReport'
export const wechatExcellentMapReport = '/Admin/WeChatExcellent/MapReport'
export const wechatExcellentNewDealerReport = '/Admin/WeChatExcellent/NewDealerReport'
export const wechatExcellentNewDealerReportExport = '/Admin/WeChatExcellent/NewDealerReportExport'
export const wechatExcellentRecommendReport = '/Admin/WeChatExcellent/DealerRecommendReport'
export const wechatExcellentRecommendReportExport = '/Admin/WeChatExcellent/DealerRecommendReportExport'
export const wechatExcellentDealerTempBounReport = '/Admin/WeChatExcellent/DealerTempBounReport'
export const wechatExcellentDealerTempBounExport = '/Admin/WeChatExcellent/DealerTempBounExport'
export const wechatExcellentTeamBounsList = '/Admin/WeChatExcellent/TeamBounsList'
export const wechatExcellentTeamBounsListExport = '/Admin/WeChatExcellent/TeamBounsListExport'
export const wechatExcellentTeramBounsOrderList = '/Admin/WeChatExcellent/TeamBounsOrderList'

// News
export const weChatExcellentNewsList = '/Admin/WeChatExcellent/NewsList'
export const weChatExcellentNewsDelete = '/Admin/WeChatExcellent/DeleteNews'
export const weChatExcellentNewsEdit = '/Admin/WeChatExcellent/EditNews'
export const weChatExcellentNewsAdd = '/Admin/WeChatExcellent/AddNews'
export const weChatExcellentNewsInfo = '/Admin/WeChatExcellent/NewsInfo'
export const uploadPictures = '/Admin/WeChatExcellent/UploadPhoto'
export const updateNewsStatus = '/Admin/WeChatExcellent/UpdateStatus'

// dealerStock
export const dealerStockList = '/Admin/WeChatExcellent/DealerStockList'
export const dealerStockIncrease = '/Admin/WeChatExcellent/IncreaseDealerStock'
export const dealerStockEdit = '/Admin/WeChatExcellent/EditDealerStock'
export const dealerStockExport = '/Admin/WeChatExcellent/ExportDealerStock'
//  wechatExcellent Order
export const wechatExcellentOrderList = '/Admin/WeChatExcellent/WeChatExcellentOrderList'
export const wechatExcellentOrderInfo = '/Admin/WeChatExcellent/WeChatExcellentOrderInfo'
export const wechatExcellentOrderClose = '/Admin/WeChatExcellent/WeChatExcellentOrderClose'
export const wechatExcellentOrderConfirm = '/Admin/WeChatExcellent/WeChatExcellentOrderConfirm'
export const wechatExcellentOrderFinished = '/Admin/WeChatExcellent/WeChatExcellentOrderFinished'
export const wechatExcellentOrderExport = '/Admin/WeChatExcellent/WeChatExcellentOrderExport'
export const wechatExcellentOrderExportByIds = '/Admin/WeChatExcellent/wechatExcellentOrderExportByIds'
export const weChatExcellentOrderShipped = '/Admin/WeChatExcellent/WeChatExcellentOrderShipped'
export const weChatExcellentDealerOrderCount = '/Admin/WeChatExcellent/DealerOrderCount'

//  wechatExcellent Invoice
export const weChatExcellentInvoiceList = '/Admin/WeChatExcellent/WeChatExcellentInvoiceList'
export const weChatExcellentInvoiceInfo = '/Admin/WeChatExcellent/WeChatExcellentInvoiceInfo'

// ConsumerFeedback
export const weChatExcellentConsumerFeedbackList = '/Admin/WeChatExcellent/ConsumerFeedbackList'
export const weChatExcellentConsumerFeedbackDelete = '/Admin/WeChatExcellent/ConsumerFeedbackDelete'

// FengYeRedpacket
export const redpacketActivityList = '/Admin/FengYeRedPacket/RedpacketActivityList'
export const delRedPacketActivity = '/Admin/FengYeRedPacket/DelRedPacketActivity'
export const editRedpacketActivity = '/Admin/FengYeRedPacket/EditRedpacketActivity'
export const redPacketActivityInfo = '/Admin/FengYeRedPacket/RedPacketActivityInfo'
export const redpacketLoadIssureRecords = '/Admin/FengYeRedPacket/RedpacketLoadIssureRecords'
export const redpacketActivityTypeList = '/Admin/FengYeRedPacket/RedpacketActivityTypeList'
export const addRedpacketActivity = '/Admin/FengYeRedPacket/AddRedpacketActivity'
export const redPacketAwardList = '/Admin/FengYeRedPacket/RedPacketAwardList'
export const delRedPacketAward = '/Admin/FengYeRedPacket/DelRedPacketAward'
export const uploadRedPacketAwardPhoto = '/Admin/FengYeRedPacket/UploadRedPacketAwardPhoto'
export const redPacketAwardTypeList = '/Admin/FengYeRedPacket/RedPacketAwardTypeList'
export const addRePacketAward = '/Admin/FengYeRedPacket/AddRePacketAward'
export const editRedPacketAward = 'Admin/FengYeRedPacket/EditRedPacketAward'
export const redPacketAwardInfo = 'Admin/FengYeRedPacket/RedPacketAwardInfo'
export const redPacketLotteryRecordList = 'Admin/FengYeRedPacket/RedPacketLotteryRecordList'
export const editRedPacketLotteryRecord = 'Admin/FengYeRedPacket/EditRedPacketLotteryRecord'
export const redPacketLotteryRecordInfo = 'Admin/FengYeRedPacket/RedPacketLotteryRecordInfo'

// CompanyInfo
export const saveCompanyInfo = '/Admin/AntiChannelConflict/saveCompanyInfo'
export const companyInfo = '/Admin/AntiChannelConflict/companyInfo'

// Challenge
export const baseCodeList = 'Admin/Challenge/baseCodeList'
export const signInCodeList = 'Admin/Challenge/signInCodeList'
export const importIssuerCodeRef = '/Admin/IssuerCodes/ImportIssuerCodeRef'
// JinLuXin
export const jinLuXinAddProduct = '/Admin/jinLuXin/AddProduct'
export const jinLuXinEditProduct = '/Admin/jinLuXin/EditProduct'

// AutoTable
export const addAutoTable = '/Admin/AutoTable/Add'
export const getAutoTable = '/Admin/AutoTable/GetInfo'
export const editAutoTable = '/Admin/AutoTable/Edit'
export const autoTableList = '/Admin/AutoTable/List'
export const delAutoTable = '/Admin/AutoTable/Del'
export const autoTableFiledList = '/Admin/AutoTable/FiledList'
export const autoTableJoinFiledList = '/Admin/AutoTable/JoinFiledList'

// miniprogram
export const uploadQrCodeLogo = '/MarketingAYB/Admin/UploadLogo'
export const getMiniProgramConfigForEdit = '/MarketingAYB/Admin/GetMiniProgramConfigForEdit'
export const editMiniProgramConfig = '/MarketingAYB/Admin/EditMiniProgramConfig'
export const miniImageList = '/MarketingAYB/Admin/ImageList'
export const batchDeleteImage = '/MarketingAYB/Admin/BatchDeleteImage'
export const exportImageList = '/MarketingAYB/Admin/ImageRecordExport'

// agent
export const getAgentPaged = '/MarketingJinguan/Admin/GetAgentPaged'
export const getAgentForEdit = '/MarketingJinguan/Admin/GetAgentForEdit'
export const createOrUpdateAgent = '/MarketingJinguan/Admin/CreateOrUpdateAgent'
export const deleteAgent = '/MarketingJinguan/Admin/DeleteAgent'
export const importAgent = '/MarketingJinguan/Admin/ImportAgent'

// Supermarket
export const getSupermarketPaged = '/MarketingJinguan/Admin/GetSupermarketPaged'
export const getSupermarketForEdit = '/MarketingJinguan/Admin/GetSupermarketForEdit'
export const createOrUpdateSupermarket = '/MarketingJinguan/Admin/CreateOrUpdateSupermarket'
export const deleteSupermarket = '/MarketingJinguan/Admin/DeleteSupermarket'
export const importSupermarket = '/MarketingJinguan/Admin/ImportSupermarket'

// MarketingAction
export const getMarketingActionPaged = '/MarketingJinguan/Admin/GetMarketingActionPaged'
export const getMarketingActionForEdit = '/MarketingJinguan/Admin/GetMarketingActionForEdit'
export const createOrUpdateMarketingAction = '/MarketingJinguan/Admin/CreateOrUpdateMarketingAction'
export const deleteMarketingAction = '/MarketingJinguan/Admin/DeleteMarketingAction'
export const importMarketingAction = '/MarketingJinguan/Admin/ImportMarketingAction'

// MarketingImagesJg
export const getMarketingImagesPaged = '/MarketingJinguan/Admin/GetMarketingImagesPaged'
export const deleteMarketingImages = '/MarketingJinguan/Admin/DeleteMarketingImages'
export const exportMarketingImages = '/MarketingJinguan/Admin/ExportMarketingImages'
export const approveImage = '/MarketingJinguan/Admin/AproveImage'
export const batchAproveImage = '/MarketingJinguan/Admin/batchAproveImage'

export const exportImages = '/MarketingJinguan/Admin/ExportImages'

// YaTeWei product
export const addYWTProduct = '/MarketingYWT/Admin/AddYWTProduct'
export const editYWTProduct = '/MarketingYWT/Admin/EditYWTProduct'
export const yWTProductInfo = '/MarketingYWT/Admin/YWTProductInfo'
export const useVideoUpload = '/MarketingYWT/Admin/UploadUseVideo'
export const importYwtProducts = '/MarketingYWT/Admin/ImportYwtProducts'
export const changeYwtProductName = '/MarketingYWT/Admin/ChangeYwtProductName'

// YaTeWei productCategory
export const yWTProductCategoryList = '/MarketingYWT/Admin/YWTProductCategoryList'
export const addYWTProductCategory = '/MarketingYWT/Admin/AddYWTProductCategory'
export const editYWTProductCategory = '/MarketingYWT/Admin/EditYWTProductCategory'
export const yWTProductCategoryInfo = '/MarketingYWT/Admin/YWTProductCategoryInfo'
export const setYWTProductCategorySort = '/MarketingYWT/Admin/SetYWTProductCategorySort'

// YaTeWei Integral
export const ywtIntegralList = '/MarketingYWT/Admin/IntegralList'
export const ywtIntegralInfo = '/MarketingYWT/Admin/IntegralInfo'
export const addYWTIntegral = '/MarketingYWT/Admin/AddIntegral'
export const editYWTIntegral = '/MarketingYWT/Admin/EditIntegral'
export const delYWTIntegral = '/MarketingYWT/Admin/DelIntegral'
export const editYWTIntegralStatus = '/MarketingYWT/Admin/EditIntegralStatus'

// YaWeiTe Member
export const memberList = '/MarketingYWT/Admin/MemberList'
export const memberInfo = '/MarketingYWT/Admin/MemberInfo'
export const changeMemberStatu = '/MarketingYWT/Admin/ChangeMemberStatu'
export const memberExport = '/MarketingYWT/Admin/MemberExport'
export const plumberExport = '/MarketingYWT/Admin/PlumberExport'

// YaWeiTe InstallRegister
export const installRegisterList = '/MarketingYWT/Admin/InstallRegisterList'
export const installRegisterInfo = '/MarketingYWT/Admin/InstallRegisterInfo'
export const updateInstallRegisterStatu = '/MarketingYWT/Admin/UpdateInstallRegisterStatu'
export const installRegisterCancelAudit = '/MarketingYWT/Admin/InstallRegisterCancelAudit'
export const installExport = '/MarketingYWT/Admin/InstallExport'

// YaWeiTe ServiceOrder
export const serviceOrderList = '/MarketingYWT/Admin/ServiceOrderList'
export const serviceOrderListExport = '/MarketingYWT/Admin/ServiceOrderListExport'
export const serviceOrderInfo = '/MarketingYWT/Admin/ServiceOrderInfo'
export const updateServiceOrderStatu = '/MarketingYWT/Admin/UpdateServiceOrderStatu'

// YaWeiTe MemberIntegralList
export const memberIntegralList = '/MarketingYWT/Admin/MemberIntegralList'
export const memberIntegralExport = '/MarketingYWT/Admin/MemberIntegralExport'



// WEBPACK FOOTER //
// ./src/api/index.js